const initialFormData = {
  // Cover sheet
  employeeName: "",
  dob: "",
  gender: "",
  address: "",
  employeePhone: "",
  email: "",
  currentlyWorkingPCA: "",
  currentHoursPerWeek: "",
  // Client assigned
  clientName: "",
  clientDOB: "",
  clientGender: "",
  clientAddress: "",
  clientCity: "",
  clientState: "MN",
  clientZip: "",
  clientPhone: "",
  clientInsurance: "",
  additionalInfo: "",

  // Application for Employment
  lastName: "",
  firstName: "",
  middleInitial: "",
  ssn: "",
  streetAddress: "",
  cityStateZip: "",
  phoneNumber: "",
  legalEligibility: "",
  positionDesired: "",
  wageSalaryDesired: "",
  employmentType: "",
  startDate: "",
  age: "",

  // Education & Skills
  enrolledInSchool: "",
  schoolDetails: "",
  jobSkills: "",

  // Availability
  mondayFrom: "",
  mondayTo: "",
  tuesdayFrom: "",
  tuesdayTo: "",
  wednesdayFrom: "",
  wednesdayTo: "",
  thursdayFrom: "",
  thursdayTo: "",
  fridayFrom: "",
  fridayTo: "",
  saturdayFrom: "",
  saturdayTo: "",
  sundayFrom: "",
  sundayTo: "",
  availableHoursPerWeek: "",
  specialRequests: "",

  // References
  ref1Name: "",
  ref1Occupation: "",
  ref1Relationship: "",
  ref1Phone: "",
  ref1HowLong: "",
  ref2Name: "",
  ref2Occupation: "",
  ref2Relationship: "",
  ref2Phone: "",
  ref2HowLong: "",

  // Employment history
  employer1Name: "",
  employer1Title: "",
  employer1Address: "",
  employer1City: "",
  employer1Phone: "",
  employer1DateFrom: "",
  employer1DateTo: "",
  employer1Supervisor: "",
  employer1Reason: "",

  employer2Name: "",
  employer2Title: "",
  employer2Address: "",
  employer2City: "",
  employer2Phone: "",
  employer2DateFrom: "",
  employer2DateTo: "",
  employer2Supervisor: "",
  employer2Reason: "",

  // Criminal history
  fullLegalName: "",
  dobCriminal: "",
  disclosureSSN: "",
  employeeAddressCriminal: "",
  placeOfBirth: "",
  emailCriminal: "",
  convictedFelony: "",
  felonyDetails: "",
  criminalHistory: "",
  criminalDetails: "",

  // Direct deposit
  ddFirstName: "",
  ddMiddleName: "",
  ddLastName: "",
  ddDOB: "",
  ddLastFourSSN: "",
  ddAddress: "",
  ddCityState: "",
  ddZipCode: "",
  ddPhoneNumber: "",
  ddEmail: "",
  ddAccount: "",
  bankName: "",
  bankAccount: "",
  bankRouting: "",

  mecParticipation: "",
  mecCoverageLevel: "Single",
  mecDependents: "",

  // Job description acknowledgement checkbox
  acknowledgesDuties: false,

  // I9-ish fields
  i9CitizenStatus: "",
  i9AlienNumber: "",
  comments: "",

  //signs
  applicantSignature: null,
  caregiverSignature: null,
  hrSignature: null,

  //w-4 form
  w4FirstName: "",
  w4LastName: "",
  w4Address: "",
  w4City: "",
  w4State: "",
  w4Zip: "",
  w4SSN: "",
  w4FilingStatus: "",
  w4MultipleJobs: false,
  w4SpouseWorks: false,
  w4DependentsUnder17: "",
  w4OtherDependents: "",
  w4OtherIncome: "",
  w4Deductions: "",
  w4ExtraWithholding: "",
  w4Signature: "",
  w4Date: "",

  // I-9 Employment Eligibility Verification
  i9LastName: "",
  i9FirstName: "",
  i9MiddleInitial: "",
  i9OtherNames: "",
  i9Address: "",
  i9AptNumber: "",
  i9City: "",
  i9State: "",
  i9Zip: "",
  i9DOB: "",
  i9SSN: "",
  i9Email: "",
  i9Phone: "",
  i9CitizenStatus: "",
  i9AlienNumber: "",
  i9AdmissionNumber: "",
  i9ForeignPassportNumber: "",
  i9CountryOfIssuance: "",
  i9Signature: "",
  i9Date: "",

  // Flyte Training / Acknowledgment Form
  flyteFirstName: "",
  flyteMiddleInitial: "",
  flyteLastName: "",
  flyteSSN: "",
  flyteAddress: "",
  flyteCity: "",
  flyteState: "",
  flyteZip: "",
  flyteCompanyName: "",
  flyteMemberEmail: "",
  flyteCoverageLevel: "",
  flyteEnrollmentType: "",
  flyteHireDate: "",
  flyteEffectiveDate: "",
  flyteWaiver: false,
  flyteSignature: "",
  flyteDate: "",
  // Covered Individuals
  flyteCoveredName0: "",
  flyteCoveredSSN0: "",
  flyteCoveredDOB0: "",
  flyteCoveredGender0: "",
  flyteCoveredRelationship0: "",
  flyteCoveredCarrier0: "",
  flyteCoveredName1: "",
  flyteCoveredSSN1: "",
  flyteCoveredDOB1: "",
  flyteCoveredGender1: "",
  flyteCoveredRelationship1: "",
  flyteCoveredCarrier1: "",
  flyteCoveredName2: "",
  flyteCoveredSSN2: "",
  flyteCoveredDOB2: "",
  flyteCoveredGender2: "",
  flyteCoveredRelationship2: "",
  flyteCoveredCarrier2: "",
  flyteCoveredName3: "",
  flyteCoveredSSN3: "",
  flyteCoveredDOB3: "",
  flyteCoveredGender3: "",
  flyteCoveredRelationship3: "",
  flyteCoveredCarrier3: "",
};

export default initialFormData;